/*
 * wait returns a promise which will be executed in `ms` milliseconds. This
 * allows you to perform a function after a set delay in the `then()` portion
 * of the promise.
 *
 * @param ms number
 *
 * @return Promise
 */
const wait = (ms)=> {
  return new window.Promise((fn)=> {
    setTimeout(fn, ms);
  });
};

/*
 * retry returns a promise which will allow you to arbitrarily retry a promise
 * multiple times. This is useful if you are expecting a result but are not
 * sure when the results may come back. You can specify how long between each
 * retry and the max number of restires to make before giving up.
 *
 * @param promise Promise
 * @param delay number
 * @param retries number
 *
 * @return Promise
 */
const retry = (promise, delay, retries)=> {
  return new window.Promise((resolve, reject) => {
    return promise()
      .then(resolve)
      .catch((reason) => {
        if (retries > 0) {
          return wait(delay)
            .then(retry.bind(null, promise, delay, retries - 1))
            .then(resolve)
            .catch(reject);
        }
        return reject(reason);
      });
  });
};

export { wait, retry };
